// FIRST ACTS (R8 M5a) — the cold first activations after a ⤳ Beam, ONE a
// frame. The Beam's first play tick cost 135 ms (ltattr-K2): every subsystem
// that first runs in play (the view labels + range, the audio nodes, the
// trees' play update, the class tiles, the canopy, the far volume, the
// generator, the scope HUD) built its state in that one task. Behind the
// beam-in overlay (flat / phone: the #beam-in scrim; VR: beamBlack) each now
// gets its own frame:
//
//   arm()       at the Beam (main.js enterAt); frame 1 belongs to the ground
//               (terrain.update — never staggered: its nearReady drives the
//               latch), so it grants nothing
//   frame()     at the top of every tick
//   go(name)    at the call site: true = run it this frame. A name that has
//               run once runs every frame from then on, as before; a cold one
//               runs when the frame's one grant is still free (the tick's
//               order = the grant order), else it waits a frame
//   done        a whole frame without a refusal: every name that asks has
//               run (a name that never asks — a mode without it — holds
//               nothing); the overlay's release waits for it
//
// Worst case: n cold names -> done at the start of frame n + 2 after the Beam.
export class FirstActs {
  constructor() {
    this._on = false;
    this._ran = new Set();
    this._slot = false;         // this frame's one grant is taken
    this._refused = 0;          // refusals in this frame
    this.frames = 0;
  }
  arm() {
    this._on = true;
    this._ran.clear();
    this._refused = 0;
    this.frames = 0;
  }
  frame() {
    if (!this._on) return;
    if (this.frames > 0 && this._refused === 0) { this._on = false; return; }
    this.frames++;
    this._slot = this.frames === 1;   // frame 1: the ground's
    this._refused = 0;
  }
  go(name) {
    if (!this._on || this._ran.has(name)) return true;
    if (!this._slot) { this._slot = true; this._ran.add(name); return true; }
    this._refused++;
    return false;
  }
  get done() { return !this._on; }
}
